import { MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  fetchOfficerInfo,
  fetchTargetSavingsOfficerInfo
} from '../actions/adminActions'
import Header from '../components/Header'
import Loader from '../components/Loader'
import Paginate from '../components/Paginate'
import SideNav from '../components/SideNav'
import { avgFloat, format } from '../main'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const SingleTargetSavingsOfficerScreen = () => {
  const [currPage, setCurrPage] = React.useState(1)
  const dispatch = useDispatch()
  const { id } = useParams()
  const officerRef = useRef(true)
  const [email, setEmail] = useState('')
  const [tag, setTag] = useState('')
  const year = new Date().getFullYear()
  const [startDate, setStartDate] = useState(new Date(year, 0, 1))
  const [endDate, setEndDate] = useState(new Date())

  const getSingleTargetSavingsOfficerInfo = useSelector(
    (state) => state.getSingleTargetSavingsOfficerInfo
  )
  const { loading, success, singletargetSavingsOfficer, error } =
    getSingleTargetSavingsOfficerInfo

  const singleOfficerInfo = useSelector((state) => state.singleOfficerInfo)
  const { success: singleOfficerSuccess, singleOfficer: officerInfo } =
    singleOfficerInfo

  console.log(officerInfo)
  useEffect(() => {
    if (officerRef.current) {
      dispatch(fetchTargetSavingsOfficerInfo(id))
      dispatch(fetchOfficerInfo(id))
      officerRef.current = false
    }
  }, [id, dispatch])

  const afterPageClicked = (page_number) => {
    if (page_number === currPage) {
      setCurrPage(page_number + 1)
    } else {
      setCurrPage(page_number)
    }
  }

  const [styles, setStyles] = useState({
    navContainer: {
      display: 'none'
    }
  })

  const handleClick = () => {
    if (styles.navContainer.display === 'block') {
      setStyles({
        navContainer: {
          display: 'none'
        }
      })
    } else {
      setStyles({
        navContainer: {
          display: 'block'
        }
      })
    }
  }

  const handleClear = () => {
    setStyles({
      navContainer: {
        display: 'none'
      }
    })
    dispatch(fetchTargetSavingsOfficerInfo(id))
  }

  const handleFilter = () => {
    setStyles({
      navContainer: {
        display: 'none'
      }
    })
    const filterData = {
      email,
      tag
    }
    dispatch(fetchTargetSavingsOfficerInfo(id, filterData, currPage))
  }

  return (
    <>
      <SideNav />
      <Helmet>
        <title> Customer | PennyTree - Admin</title>
      </Helmet>
      <section className='page-container'>
        <div className='page-content'>
          <Header />
          <div className='page-body'>
            <h1>{officerInfo?.officer_info?.name} Performance</h1>
            {loading ? (
              <Loader />
            ) : error ? (
              <p>{error}</p>
            ) : (
              <>
                <div className='filter-box'>
                  <div className='filter'>
                    <>
                      <div className='filter-container'>
                        <p style={{ cursor: 'pointer' }} onClick={handleClick}>
                          Filter
                        </p>
                        <div
                          className='navContainer'
                          style={styles.navContainer}
                        >
                          <div className='date-filter'>
                            <div className='date-title'>Date</div>
                            <div className='date-options'>
                              <div className='custom-filter__item custom-filter__item--pad'>
                                <div className='overview-filter'>
                                  <div className='filter__item'>
                                    <input
                                      id='today_fkc3w9c4e0'
                                      value='Today'
                                      type='radio'
                                      name='dateFilter_fkc3w9c4e0'
                                      className='overview-filter__item__radio'
                                    />
                                    <label
                                      htmlFor='today_fkc3w9c4e0'
                                      className='overview-filter__item__link active'
                                    >
                                      Today
                                    </label>
                                  </div>{' '}
                                  <div className='filter__item'>
                                    <input
                                      id='last7_fkc3w9c4e0'
                                      value='7 days'
                                      type='radio'
                                      name='dateFilter_fkc3w9c4e0'
                                      className='overview-filter__item__radio'
                                    />
                                    <label
                                      htmlFor='last7_fkc3w9c4e0'
                                      className='overview-filter__item__link'
                                    >
                                      Last 7 days
                                    </label>
                                  </div>{' '}
                                  <div className='filter__item'>
                                    <input
                                      id='last30_fkc3w9c4e0'
                                      value='30 days'
                                      type='radio'
                                      name='dateFilter_fkc3w9c4e0'
                                      className='overview-filter__item__radio'
                                    />
                                    <label
                                      htmlFor='last30_fkc3w9c4e0'
                                      className='overview-filter__item__link'
                                    >
                                      30 days
                                    </label>
                                  </div>{' '}
                                  <div className='filter__item'>
                                    <input
                                      id='1year_fkc3w9c4e0'
                                      value='1 year'
                                      type='radio'
                                      name='dateFilter_fkc3w9c4e0'
                                      className='overview-filter__item__radio'
                                    />
                                    <label
                                      htmlFor='1year_fkc3w9c4e0'
                                      className='overview-filter__item__link'
                                    >
                                      1 year
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className='date-content'>
                                <div className='date-items'>
                                  <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                  />

                                  <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className='status-container'>
                            <div className='date-title'>Customer</div>
                            <div className='checkbox checkbox--flex'>
                              <div
                                className='checkbox__item'
                                style={{
                                  width: '100%'
                                }}
                              >
                                <input
                                  style={{
                                    width: '100%',
                                    borderRadius: '10px',
                                    border: '1px solid grey',
                                    fontSize: '14px',
                                    display: tag ? ' none' : 'block'
                                  }}
                                  type='email'
                                  className='email-input'
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  placeholder='Enter customer Email'
                                />{' '}
                              </div>
                              <div
                                className='checkbox__item'
                                style={{
                                  width: '100%'
                                }}
                              >
                                <input
                                  style={{
                                    width: '100%',
                                    borderRadius: '10px',
                                    border: '1px solid grey',
                                    fontSize: '14px',
                                    display: email ? ' none' : 'block'
                                  }}
                                  type='text'
                                  className='email-input'
                                  value={tag}
                                  onChange={(e) => setTag(e.target.value)}
                                  placeholder='Enter Penntag or merchant Tag'
                                />{' '}
                              </div>
                            </div>
                          </div>
                          <div
                            className='status-container'
                            style={{
                              display: 'flex',
                              justifyContent: 'space-evenly',
                              alignItems: 'center'
                            }}
                          >
                            <button className='button' onClick={handleClear}>
                              <p>Clear</p>
                            </button>
                            <button className='button' onClick={handleFilter}>
                              <p>Filter</p>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>

                <MDBTable responsive style={{ 'width': '100%' }}>
                  <MDBTableHead>
                    <tr>
                      <th scope='col'>S/N</th>
                      <th scope='col'>Customer Name</th>
                      <th scope='col'>Email Address</th>
                      <th scope='col'>Username</th>
                      <th scope='col'>Savings Name</th>
                      <th scope='col'>Individual Account Number</th>
                      <th scope='col'>Merchant Account Number</th>
                      <th scope='col'>Target Amount</th>
                      <th scope='col'>Date Created</th>
                      <th scope='col'>Start Date</th>
                      <th scope='col'>End Date</th>
                      <th scope='col'>Debit Amount</th>
                      <th scope='col'>Last Debit Date</th>
                      <th scope='col'>Next Debit Date</th>
                      <th scope='col'>Frequency</th>
                      <th scope='col'>No Of Debits</th>
                      <th scope='col'>Amount Saved</th>
                      <th scope='col'>Wallet Balance</th>
                      <th scope='col'>Actions</th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {success &&
                      singletargetSavingsOfficer?.items?.map((tran, key) => (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>
                            {tran?.first_name} {tran?.last_name}
                          </td>
                          <td>{tran?.email_address}</td>
                          <td>{tran?.username}</td>
                          <td>{tran?.purpose}</td>
                          <td>{tran?.individual_account_number}</td>
                          <td>{tran?.merchant_account_number}</td>
                          <td>{format(tran?.target_amount)}</td>
                          <td>{moment(tran?.date_created).format('LLL')}</td>
                          <td>{moment(tran?.start_date).format('LLL')}</td>
                          <td>{moment(tran?.end_date).format('LLL')}</td>
                          <td>{format(tran?.debit_amount)}</td>
                          <td>
                            {moment(tran?.last_collection_date).format('LLL')}
                          </td>
                          <td>
                            {moment(tran?.next_collection_date).format('LLL')}
                          </td>
                          <td>{tran?.frequency}</td>
                          <td>{tran?.no_of_debits}</td>
                          <td>{format(tran?.amount_saved)}</td>
                          <td>{format(tran?.wallet_balance)}</td>

                          <td>
                            <button className='withdrawal-btn'>
                              <a href={`/${tran?.id}`}>View More</a>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </MDBTableBody>
                </MDBTable>
                <Paginate
                  totPages={singletargetSavingsOfficer?.page?.total_page}
                  currentPage={String(
                    singletargetSavingsOfficer?.page?.current_page
                  )}
                  page={String(singletargetSavingsOfficer?.page?.current_page)}
                  pageClicked={(ele) => {
                    afterPageClicked(ele)
                  }}
                />
              </>
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default SingleTargetSavingsOfficerScreen
